<template>
  <div id="app">
    <div class="border border-left"></div>
    <div class="border border-right"></div>
    <div class="border border-top"></div>
    <div class="border border-bottom"></div>
    <div id="loading-spinner">
      <div id="loading"></div>
    </div>
    <div class="main-content">
      <router-view/>
    </div>
    <footer-prismic/>
  </div>
</template>

<script>
var images = require.context("@/assets/img/", false, /\.*/);
import FooterPrismic from './components/FooterPrismic.vue';

export default {
  name: "App",
  components: { FooterPrismic },
  created () {
    // `this` points to the vm instance
    this.doAjax();
  },
  methods: {
    doAjax() {
      // simulate AJAX
      setTimeout(() => {
        document.documentElement.classList.remove('loading');
        document.getElementById('loading-spinner').classList.add('hidden')
      }, 750);
    },
    imgUrl: function(path) {
      return images("./" + path);
    },
    beforeEnter: function(el) {
      el.style.opacity = 0;
    },
    enter: function(el, done) {
      Velocity(el, { opacity: 1 }, { duration: 300 });
    },
    leave: function(el, done) {
      Velocity(el, { opacity: 0 }, { complete: done });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~bulma/sass/utilities/_all";
@import "./assets/css/resetr.css";
@import "./assets/css/prismic-edit-button.css";
@import "./assets/sass/colors.scss";

#loading-spinner {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  background: white;
  opacity: 1;
  transition: .3s all;
  &.hidden {
    opacity: 0;
    z-index: -1000;
  }
}

.border {
  z-index: 500;
  background: $teal;
  position: fixed;
  
  &.border-left {
    top: 0; 
    bottom: 0;
    left: 0;
    width: 10px;
  }

  &.border-right {
    top: 0; 
    bottom: 0;
    right: 0;
    width: 10px;
  }

  &.border-top {
    left: 0; 
    right: 0;
    top: 0;
    height: 10px;
  }

  &.border-bottom {
    left: 0; 
    right: 0;
    bottom: 0;
    height: 10px;
  }
}

#loading {
    border-radius: 50%;
    width: 24px;
    height: 24px;
    border: .25rem solid rgba(18, 28, 77, 0.2);
    border-top-color: rgb(18, 28, 77);
    animation: spin 1s infinite linear;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

img {
  &.portrait {
    position: fixed;
    left: 0;
    max-width: 50vw;
    top: 7rem;
    @media screen and (max-width: $widescreen) {
      width: 50vw;
    }
    @media screen and (max-width: $desktop) {
      top: 12rem;
    }
  }
}

.router-anim-enter-active {
  animation: coming 1s;
  animation-delay: 0.5s;
  opacity: 0;
}
.router-anim-leave-active {
  animation: going 1s;
}

@keyframes going {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-50px);
    opacity: 0;
  }
}
@keyframes coming {
  from {
    transform: translateX(-50px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
</style>
